import { styled } from '../jss-style';
import treeSelectStyle from './tree-select';

const useTreeSelectStyle = styled(treeSelectStyle, 'treeSelect');
export { treeSelectStyle, useTreeSelectStyle };
export default useTreeSelectStyle;
